import { render, staticRenderFns } from "./CustomerFormGroup.vue?vue&type=template&id=e8e9ec04"
import script from "./CustomerFormGroup.vue?vue&type=script&lang=js"
export * from "./CustomerFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports